'use client'

import { useRouter } from 'next/navigation'
import { useRef } from 'react'

import { Card } from '@/entities/auth'
import { Slot } from '@/shared/lib'
import { useDialog } from '@/shared/lib'
import { AlertDialog } from '@/shared/ui'

import { FindIDForm } from './find-id-form'

const DIALOG = {
  FIND_ID_COMPLETE: 'FIND_ID_COMPLETE',
} as const

type FindIDDialog = keyof typeof DIALOG

export const FindIDPage = () => {
  const router = useRouter()
  const { isOpen, open, close } = useDialog<FindIDDialog>()
  const emailRef = useRef('')

  const closeDialog = (key: FindIDDialog) => () => {
    close(key)
  }

  const handleSuccess = (username: string) => {
    const [name, domain] = username.split('@')
    const maskedName = name.length > 2 ? `${name.slice(0, -2)}**` : name

    emailRef.current = `${maskedName}@${domain}`

    open(DIALOG.FIND_ID_COMPLETE)
  }

  const handleConfirm = () => {
    close(DIALOG.FIND_ID_COMPLETE)

    router.push('/sign-in')
  }

  return (
    <>
      <Card>
        <Slot name="title">아이디 찾기</Slot>
        <Slot name="description">
          이름과 휴대폰 번호를 통해
          <br />
          가입하신 이메일 주소를 확인합니다.
        </Slot>
        <Slot name="children">
          <FindIDForm onSuccess={handleSuccess} />
        </Slot>
      </Card>
      <AlertDialog
        isOpen={isOpen(DIALOG.FIND_ID_COMPLETE)}
        onOpenChange={closeDialog(DIALOG.FIND_ID_COMPLETE)}
        title="아이디 찾기가 완료되었습니다"
        content={`가입하신 아이디는\n${emailRef.current} 입니다.`}
        onConfirm={handleConfirm}
        preventOutsideClick
      />
    </>
  )
}
